<app-nav-bar></app-nav-bar>

<div class="app-content" style="padding-top: 53px">
  <app-notifications></app-notifications>
  <app-profile></app-profile>
  <app-wrapper></app-wrapper>
</div>

<app-footer-desktop class="d-none d-lg-block"></app-footer-desktop>
<app-footer-mobile  class="d-lg-none app-mobile"></app-footer-mobile>
